import {Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BicButtonComponent, BicPopupComponent} from '@buildinginformationcloud/bic-ui-components';

@Component({
    selector: 'app-unsavedChangesDialog',
    templateUrl: './unsaved-changes-dialog.component.html',
    styleUrls: ['./unsaved-changes-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [BicButtonComponent, BicPopupComponent]
})
export class UnsavedChangesDialogComponent implements OnInit {
  data = inject<{}>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<UnsavedChangesDialogComponent>>(MatDialogRef);


  result: string = "";

  ngOnInit(): void {
  }

  discardClicked(){
    this.dialogRef.close("discard");
  }

  cancelClicked(){
    this.dialogRef.close("cancel");
  }

}
